import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Play, ArrowLeft, Download } from 'lucide-react';
import { Button } from '../components/ui/button';

const PromoVideo = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/promo_video.mp4';
    link.download = 'Infused_by_Daizy_Promo.mp4';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-950 via-purple-900 to-purple-950 py-20">
      <div className="container mx-auto px-4">
        {/* Back Button */}
        <Link to="/">
          <Button variant="ghost" className="text-purple-300 hover:text-white mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </Link>

        {/* Header */}
        <div className="text-center mb-12">
          <Sparkles className="w-12 h-12 mx-auto mb-4 text-yellow-400" />
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Infused by Daizy
          </h1>
          <p className="text-xl text-purple-200">Sacred Drops of Love and Light</p>
        </div>

        {/* Video Player */}
        <div className="max-w-4xl mx-auto">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-purple-900/50 border border-purple-600">
            <video 
              controls 
              autoPlay
              muted
              loop
              className="w-full"
              poster=""
            >
              <source src="/promo_video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Description */}
          <div className="mt-8 text-center">
            <p className="text-purple-200 text-lg mb-6">
              Experience the magic of our hand-crafted ritual oils, anointed with sacred herbs 
              and charged under the moonlight. Each bottle is infused with love, intention, 
              and divine energy to support your spiritual journey.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/products">
                <Button className="bg-yellow-500 hover:bg-yellow-600 text-purple-900 font-semibold px-8 py-6 text-lg">
                  <Play className="w-5 h-5 mr-2" />
                  Shop Our Collection
                </Button>
              </Link>
              <Button 
                onClick={handleDownload}
                variant="outline"
                className="border-yellow-500 text-yellow-400 hover:bg-yellow-500/20 font-semibold px-8 py-6 text-lg"
              >
                <Download className="w-5 h-5 mr-2" />
                Download Video
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromoVideo;
